var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.2116C12.9435 13.2116 13.7419 12.885 14.3951 12.2317C15.0484 11.5785 15.375 10.7801 15.375 9.83662C15.375 8.89312 15.0484 8.09475 14.3951 7.4415C13.7419 6.78825 12.9435 6.46162 12 6.46162C11.0565 6.46162 10.2581 6.78825 9.60487 7.4415C8.95162 8.09475 8.625 8.89312 8.625 9.83662C8.625 10.7801 8.95162 11.5785 9.60487 12.2317C10.2581 12.885 11.0565 13.2116 12 13.2116ZM4.818 21C4.29975 21 3.86737 20.8267 3.52087 20.4802C3.17437 20.1337 3.00075 19.701 3 19.182V4.818C3 4.29975 3.17362 3.86737 3.52087 3.52087C3.86812 3.17437 4.3005 3.00075 4.818 3H19.1831C19.7006 3 20.133 3.17362 20.4802 3.52087C20.8275 3.86812 21.0007 4.3005 21 4.818V19.1831C21 19.7006 20.8267 20.133 20.4802 20.4802C20.1337 20.8275 19.701 21.0007 19.182 21H4.818ZM4.60087 19.875H19.3991C19.5581 19.7752 19.6665 19.6425 19.7242 19.4767C19.782 19.311 19.8322 19.1565 19.875 19.0132C18.8625 18.0195 17.6861 17.2369 16.3459 16.6654C15.0056 16.0939 13.557 15.8081 12 15.8081C10.443 15.8081 8.99437 16.0939 7.65412 16.6654C6.31387 17.2369 5.1375 18.0199 4.125 19.0144C4.1685 19.1569 4.21875 19.311 4.27575 19.4767C4.33275 19.6425 4.44112 19.7752 4.60087 19.875Z",
    fill: "#D20F3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.d57e886050b118a540d3b5c9e06a42f9.svg";
export { ForwardRef as ReactComponent };